import React from "react";
import { useTranslation } from "react-i18next";
import { Add, EmptyStateIllustration } from "@dreamhub/designsystem/icons";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import IconContainer from "@/components/ui/icon-container";
import { PartnerTab } from "@/pages/partners/types";

interface Props {
  tab: PartnerTab;
  onAdd: () => void;
}

const PartnerTabEmptyState: React.FC<Props> = ({ tab, onAdd }) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-12 items-center">
      <div className="w-[300px] shrink-0 [&>svg]:w-full [&>svg]:h-auto">
        <EmptyStateIllustration />
      </div>
      <div className="flex flex-col gap-10 items-start w-[330px]">
        <div className="flex flex-col gap-6">
          <Text variant="lgSubtitle" className="normal-case">
            {t(`partners.detailedView.${tab}.empty`)}
          </Text>
          <Text variant="lgBodySecondary">
            {t(`partners.detailedView.${tab}.emptyDescription`)}
          </Text>
        </div>
        <Button
          size="lg"
          onClick={onAdd}
          className="w-fit flex"
          data-test={`partner-${tab}-empty-state-add-button`}
        >
          <IconContainer size="5">
            <Add />
          </IconContainer>
          {t(`partners.detailedView.${tab}.addCta`)}
        </Button>
      </div>
    </div>
  );
};

export default PartnerTabEmptyState;
